import React from 'react';
import './StationView.less';

import useRadioLiveController from '../../../shared/RadioLiveSection/useRadioLiveController';

import {
  radioPlayerPause,
  radioPlayerPlayLive,
} from '../../../../utils/radioPlayerEvents';

import { PlayWhite, PauseIconSmall } from 'volto-ebc-radiomec/components/Icons';

type Props = {
  content: any;
};

function StationPlayIcon({ active }: { active: boolean }) {
  return active ? (
    <PauseIconSmall
      className="stationView__buttonIcon stationView__buttonIcon--pause"
      aria-hidden="true"
    />
  ) : (
    <PlayWhite className="stationView__buttonIcon" aria-hidden="true" />
  );
}

const getImageUrl = (content: any) =>
  content?.image?.scales?.large?.download ||
  content?.image?.scales?.teaser?.download ||
  content?.image?.download ||
  '';

const StationView = ({ content }: Props) => {
  const imageUrl = getImageUrl(content);
  const transmission = content?.transmission || [];

  const { stations, currentStationId, isPlaying, isLiveMode } =
    useRadioLiveController({
      analyticsSection: 'station.hero',
      analyticsOrigin: 'StationView',
    });

  const currentStation = React.useMemo(() => {
    return stations.find((station) => {
      const stationTitle =
        `${station.title || ''} ${station.shortName || ''}`.toLowerCase();

      return (
        stationTitle.includes(content?.title_abbr?.toLowerCase?.() || '') ||
        stationTitle.includes(content?.title?.toLowerCase?.() || '')
      );
    });
  }, [stations, content]);

  const isStationActive =
    !!currentStation &&
    isLiveMode &&
    isPlaying &&
    currentStationId === currentStation.id;

  function handleStationToggle() {
    if (!currentStation) return;

    if (isStationActive) {
      radioPlayerPause();
      return;
    }

    radioPlayerPlayLive(currentStation.id, {
      origin: 'StationView',
      analytics: {
        event: 'audio_play',
        section: 'station.hero',
        contentType: 'radio',
        stationId: currentStation.id,
        label: currentStation.shortName || currentStation.title || 'Rádio MEC',
      },
    });
  }

  return (
    <main className="stationView">
      <section className="stationView__hero">
        <div className="stationView__content">
          <p className="stationView__eyebrow">Emissora Rádio MEC</p>

          <h1>{content?.title}</h1>

          {content?.description && (
            <p className="stationView__description">{content.description}</p>
          )}

          <div className="stationView__meta">
            {content?.title_abbr && <span>{content.title_abbr}</span>}

            {transmission.length > 0 && <span>{transmission.join(' • ')}</span>}
          </div>

          {content?.stream_url && (
            <button
              className={`stationView__button ${
                isStationActive ? 'is-active' : ''
              }`}
              type="button"
              disabled={!currentStation}
              onClick={handleStationToggle}
              aria-pressed={isStationActive}
            >
              <StationPlayIcon active={isStationActive} />

              <span>
                {isStationActive ? 'Pausar transmissão' : 'Ouvir ao vivo'}
              </span>
            </button>
          )}
        </div>

        {imageUrl && (
          <div className="stationView__cover">
            <img src={imageUrl} alt={content?.title || 'Emissora'} />
          </div>
        )}
      </section>

      {content?.about && (
        <section className="stationView__about">
          <span>Sobre a emissora</span>
          <p>{content.about}</p>
        </section>
      )}
    </main>
  );
};

export default StationView;
